import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function ErrorIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = "error";
  const color = props.color || defaultColor;
  return (
    <SvgIcon
      {...props}
      color={color}
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 24 24"
      xmlSpace="preserve"
      enableBackground="new 0 0 24 24"
      titleAccess="Error"
    >
      <path d="M1.39896 17.5711L9.36212 2.86993C10.4968 0.775058 13.5032 0.77506 14.6379 2.86993L22.601 17.5712C23.6838 19.5701 22.2365 22 19.9632 22H4.03684C1.76353 22 0.316223 19.5701 1.39896 17.5711Z" fill="#D52043"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V7ZM13.25 18.2499C13.25 17.5596 12.6904 16.9999 12 16.9999C11.3096 16.9999 10.75 17.5596 10.75 18.2499V18.2923C10.75 18.9827 11.3096 19.5423 12 19.5423C12.6904 19.5423 13.25 18.9827 13.25 18.2923V18.2499Z" fill="white"/>
    </SvgIcon>
  );
}